import React, { useEffect, useCallback, useRef } from "react";
import {toast} from "react-toastify";
import Unauthorized from "./Unauthorized";
import Header from "./Header";
import ChatDisableModal from "./Modals/ChatDisableModal";
import EmptyChannelMessage from "./EmptyChannelMessage";
import {
    Chat,
    Channel,
    MessageInput,
    Window,
    Thread,
    MessageList,
} from "stream-chat-react";
import {
    BLOCK_USER_TITLE,
    BLOCK_USER_MESSAGE,
    DELETE_USER_MESSAGE_TITLE,
    DELETE_USER_SINGLE_MESSAGE,
    EDIT_USER_MESSAGE_TITLE,
    DAY_THRESHOLD,
    Sizes,
 
} from "../constants";
import { API_URLS } from "../constants/apiUrls";
import FCMNotificationBanner from "./FCMNotificationBanner";
import EventScribeSpinner from "./shared/EventScribeSpinner";
import MessageCustomDateSeparator from "./shared/MessageCustomDateSeparator";
import {useAppSettings} from "../context/AppSettingsContext";
import EditConfirmationModal from "./Modals/EditConfirmationModal";
import "../styles/ChatPage.css";
import SideBar from "./SideBar";
import "stream-chat-react/dist/css/v2/index.css";
import "stream-chat-react/css/v2/emoji-mart.css";
import CustomChannelHeader from "./CustomChannelHeader";
import CustomThreadHeader from "./CustomThreadHeader";
import "../styles/Chat.css";
import CustomMessage from "./CustomMessage";
import CustomMessageTimestamp from "./CustomMessageTimestamp";
import CustomAvatar from "./shared/CustomAvatar";
import {useAuth} from "../context/AuthContext";
import CustomEmptyState from "./EmptyStateIndicator";
import DeleteConfirmationModal from "./Modals/DeleteConfirmationModal";
import BlockUserConfirmationModal from "./Modals/BlockUserConfirmationModal";
import {
    hideAndDeleteChannelForUser,
    handleDeleteMessage,
    createAndInitializeChannel,
    fetchUserDetails,
    loadMoreMessages,
    blockUser,
} from "../utils/chatUtils";
import {CustomInput} from "./CustomInput";
import CustomTypingIndicator from "./CustomTypingIndicator";
import ChatMessageActions from "./ChatMessageActions";
import { shouldShowAvatar } from '../utils/shouldShowAvatar';
import { useChatStore } from '../store/useChatStore';
import { useChatDisabled } from "../hooks/useChatDisabled";
import { useOverlayActive } from "../hooks/useOverlayActive";
import { useOpenPendingAppointment } from "../hooks/useOpenPendingAppointment";
import { useRemoveCanceledAppointmentLink } from "../hooks/useRemoveCanceledAppointmentLink";
import { useAppointmentStore } from "../store/useAppointmentStore";
import AppointmentModal from "./Modals/AppointmentModal";
import AppointmentPopupSummary from "./Modals/AppointmentPopupSummary";
const ChatPage = ({ token }) => { 
    const isAppointmentSummaryPopupOpen = useAppointmentStore((state) => state.isAppointmentSummaryPopupOpen);

    
     

     // Read the environment variable and determine if the banner should be hidden
    const hideFCMBanner = process.env.REACT_APP_HIDE_FEATURE === "0";
    const { authData } = useAuth(); // Access the context data
    const { clientId, eventId, accountId1, accountId2 } = authData;

    const { chatClient, tokens } = useAppSettings();
    const userDetails = useChatStore((s) => s.userDetails);
    const setUserDetails = useChatStore((s) => s.setUserDetails);
    const primaryUserId = useChatStore((s) => s.primaryUserId);
    const secondaryUserId = useChatStore((s) => s.secondaryUserId);
    const setSecondaryUserId = useChatStore((s) => s.setSecondaryUserId);

    const refreshBanner = useChatStore((s) => s.refreshBanner);

    // Zustand store state and setters
    const isDeletingMessage = useChatStore((s) => s.isDeletingMessage);
    const setIsDeletingMessage = useChatStore((s) => s.setIsDeletingMessage);
    const sidebarStateChangeKey = useChatStore((s) => s.sidebarStateChangeKey);
    const isBlockModalOpen = useChatStore((s) => s.isBlockModalOpen);
    const setIsBlockModalOpen = useChatStore((s) => s.setIsBlockModalOpen);
    const hasRecentUsers = useChatStore((s) => s.hasRecentUsers);
    const setHasRecentUsers = useChatStore((s) => s.setHasRecentUsers);
    const isEditModalOpen = useChatStore((s) => s.isEditModalOpen);
    const setIsEditModalOpen = useChatStore((s) => s.setIsEditModalOpen);
    const messageToEdit = useChatStore((s) => s.messageToEdit);
    const setMessageToEdit = useChatStore((s) => s.setMessageToEdit);
    const isSidebarOpen = useChatStore((s) => s.isSidebarOpen);
    const setIsSidebarOpen = useChatStore((s) => s.setIsSidebarOpen);
    const deletingChannel = useChatStore((s) => s.deletingChannel);
    const setDeletingChannel = useChatStore((s) => s.setDeletingChannel);
    const mode = useChatStore((s) => s.mode);
    const setMode = useChatStore((s) => s.setMode);
    const activeChannel = useChatStore((s) => s.activeChannel);
    const setActiveChannel = useChatStore((s) => s.setActiveChannel);
    const loading = useChatStore((s) => s.loading);
    const setLoading = useChatStore((s) => s.setLoading);
    const error = useChatStore((s) => s.error);
    const setError = useChatStore((s) => s.setError);
    const loadingMore = useChatStore((s) => s.loadingMore);
    const setLoadingMore = useChatStore((s) => s.setLoadingMore);
    const hasMore = useChatStore((s) => s.hasMore);
    const setHasMore = useChatStore((s) => s.setHasMore);
    const chatError = useChatStore((s) => s.chatError);
    const setChatError = useChatStore((s) => s.setChatError);
    const isDeleteModalOpen = useChatStore((s) => s.isDeleteModalOpen);
    const setIsDeleteModalOpen = useChatStore((s) => s.setIsDeleteModalOpen);
    const messageToDelete = useChatStore((s) => s.messageToDelete);
    const setMessageToDelete = useChatStore((s) => s.setMessageToDelete);
    const isModalOpen = useChatStore((s) => s.isModalOpen);
    const setIsModalOpen = useChatStore((s) => s.setIsModalOpen);
    const sidebarLoading = useChatStore((s) => s.sidebarLoading);
    const setSidebarLoading = useChatStore((s) => s.setSidebarLoading);
    
    const userToBlock = useChatStore((s) => s.userToBlock);
    const setUserToBlock = useChatStore((s) => s.setUserToBlock);
    const setChatClient = useChatStore((s) => s.setChatClient);

    useEffect(() => {
        if (chatClient) setChatClient(chatClient);
    }, [chatClient, setChatClient]);

    const isChatDisabled = useChatDisabled(activeChannel);

    const {
      isSchedulePopupOpen,
      iframeUrl,
      setAppointmentSchedulePopup,
      setIframeUrl,
    } = useAppointmentStore();

    const handleCloseModal = () => {
      setAppointmentSchedulePopup(false);
      setIframeUrl("");
    };

    // Helper to connect user to chatClient, returns true if successful, false if not
    const connectChatUser = async (chatClient, userId, token) => {  
        if (!chatClient || !userId || !token) return false;
        if (chatClient.user) return true; // Already connected
        try {
            //pass function as promise instead of token
            await chatClient.connectUser({ id: userId }, token);
           
            return true;
        } catch (err) {
            setChatError(err.message || "Failed to connect to chat server1!");
            return false;
        }
    };
   
    const handleShowBlockModal = (userId) => {
        setUserToBlock(userId);
        setIsBlockModalOpen(true);
    };

    const handleCloseBlockModal = () => {
        setIsBlockModalOpen(false);
        setUserToBlock(null);
    };

    const handleBlockUser = async () => {
        if (chatClient && userToBlock) {
            await blockUser({chatClient, userIdToBlock: userToBlock});
            setIsBlockModalOpen(false);
            setUserToBlock(null);
        }
    };


    // Add these above your return in ChatPage.js
    const handleShowDeleteModal = (message) => {
        setMessageToDelete(message);
        setIsDeleteModalOpen(true);
    };
    const handleShowEditModal = (message) => {
        setMessageToEdit(message);
        setIsEditModalOpen(true);
    };

    const handleEditMessage = async (newText) => {
        if (messageToEdit && newText.trim()) {
            try {
                // Fetch the latest message by ID from the chatClient
                const updatedMessage = {
                    ...messageToEdit,
                    text: newText,
                };
                // Update the message using chatClient
                await chatClient.updateMessage(updatedMessage);

                // Optionally, refresh the active channel to ensure UI updates
                if (activeChannel) {
                    await activeChannel.watch({watch: true, state: true});
                    setActiveChannel(activeChannel);
                }
            } catch (error) {
                toast.error("Failed to update the message.", {
                    toastId: "edit-message",
                });
            }
        }
        setIsEditModalOpen(false);
        setMessageToEdit(null);
    };
    // Usage inside ChatPage (e.g., in a callback or event handler)
    const onDeleteChannel = async (userOrChannel) => {
        setDeletingChannel(true);
        try {
            const result = await hideAndDeleteChannelForUser({
                userOrChannel,
                chatClient,
                primaryUserId,
                activeChannel,
                setActiveChannel,
                setSecondaryUserId,
            });
            if (result && chatClient) {
                chatClient.dispatchEvent({
                    type: "channel.deleted.custom",
                    channelId: result.channelId,
                    userId: result.userId,
                });
            }
        } finally {
            setDeletingChannel(false);
        }
    };
    // Usage inside ChatPage (e.g., in a callback or event handler)
    const onDeleteMessage = async () => {
        setIsDeleteModalOpen(false);
       // setIsDeletingMessage(false);
        await handleDeleteMessage({
            chatClient,
            activeChannel,
            messageToDelete,
            setMessageToDelete,
        });
        if (activeChannel) {
            await activeChannel.watch({watch: true, state: true});
            setActiveChannel(activeChannel);
        }
        setIsDeletingMessage(false);
    };
    const handleFetchUserDetails = async (userIdsToFetch, callback) => {
        if (
            !Array.isArray(userIdsToFetch) ||
            userIdsToFetch.length === 0 ||
            !primaryUserId
        ) {
            return;
        }
        const result = await fetchUserDetails({
            chatClient,
            userIdsToFetch,
            primaryUserId: primaryUserId,
            setUserDetails,
            setChatError,
        });
        if (callback && typeof callback === "function") {
            callback(result);
        }
    };

    // Usage inside ChatPage (e.g., in a callback or event handler)
    const onCreateAndInitializeChannel = async (
        primaryUserId,
        secondaryUserId,
        team
    ) => {
        await createAndInitializeChannel({
            chatClient,
            primaryUserId,
            secondaryUserId,
            team,
            setLoading,
            onFetchUserDetails,
            setActiveChannel,
            setChatError,
        });
    };

    useEffect(() => {
        if (!clientId || !eventId || !accountId1) {
            setLoading(false); // Stop loading if parameters are missing
            setError(true); 
            return;
        } 
    
        setLoading(true);
        const checkUserShareStatus = async () => {
            try {
                if (!chatClient && !primaryUserId) {
                    setLoading(false); // Stop loading if parameters are missing
                    return;
                }
                if (!primaryUserId) return;
                
                if (!chatClient.user && primaryUserId) {
                        const connected = await connectChatUser(
                            chatClient,
                            primaryUserId,
                            tokens[`_stream_${token}`]
                        );
                        if (!connected) return;

                    }
                
                const usersToCheck = [primaryUserId];
                if (secondaryUserId) usersToCheck.push(secondaryUserId);

                await handleFetchUserDetails(
                    usersToCheck,
                    ({primaryUser}) => {
                        // show popup when logged in user is not active or share is false or is_active is check for deleted user
                        if (primaryUser && (!primaryUser.share || !primaryUser.is_active)) {
                            setIsModalOpen(true);
                            setLoading(false);
                            return;
                        }
                        /*if (secondaryUser && !secondaryUser.share) {
                            setIsModalOpen(true);
                            setLoading(false);
                            return;
                        }*/
                        // Proceed with channel initialization if both users have share = true
                        initializeChat();
                    }
                );
            } catch (err) {
                setLoading(false);
                setError(true);
            }
        };

        const initializeChat = async () => {
            try {
                // Set default channel from URL
                let defaultChannel;
                const team = chatClient.user?.teams ? chatClient.user.teams[0] : "";
                const sort = [{last_message_at: -1}];
                const filters = {
                    team: {$eq: team},
                    type: "messaging",
                    members: {$in: [primaryUserId]},
                    member_count: {$eq: 2},
                };

                // Query for an existing channel
                let channels = await chatClient.queryChannels(filters, sort, {
                    watch: true, // this is the default
                    state: true,
                    limit: 25,
                });
                /*if (channels.length > 0) {
                    channels = channels.filter((channel) =>
                        Object.values(channel.state.members).every(
                            (member) => member.user.share === true
                        )
                    );
                }*/

                if (secondaryUserId && channels.length > 0) {
                    const matchedChannel = channels.find(
                        (channel) => channel.state.members[secondaryUserId]
                    );

                    defaultChannel = matchedChannel || channels[0];
                } else if (primaryUserId && secondaryUserId) {
                    await onCreateAndInitializeChannel(
                        primaryUserId,
                        secondaryUserId,
                        team
                    );

                    return;
                }
                if (defaultChannel) {
                    await defaultChannel.watch({watch: true, state: true, limit: 50});
                }
                setLoading(false);

                // WebSocket listeners
                chatClient.on("connection.error", async () => {
                    // Wait 3 seconds before attempting to reconnect
                    await new Promise((resolve) => setTimeout(resolve, 3000));
                    try {
                        await chatClient.disconnectUser();
                        // Wait 5 seconds before reconnecting
                        await new Promise((resolve) => setTimeout(resolve, 5000));
                        try {
                              await connectChatUser(
                                chatClient,
                                primaryUserId,
                                tokens[`_stream_${token}`]
                            );                             
                        } catch (err) {
                            setChatError(err.message || "Stream Chat reconnection failed!");
                        }
                    } catch (err) {
                        setChatError(err.message || "Stream Chat Web Socket Failed!");
                    }
                });

                chatClient.on("connection.recovered", () => {
                    toast.success("🔁 Connection recovered automatically", {
                        toastId: "connection-recovered",
                    }); // Show success toast
                });
                  // Add token expiration handling
                  chatClient.on("token.expired", async () => {                      
                      toast.error("Your chat session has expired. Please re-login.", { toastId: "token-expired" });
                  });
                return () => {
                };
            } catch (err) {
                setChatError(err.message || "Error initializing chat!");
                setError(true);
                setLoading(false);
            }
        };

        checkUserShareStatus();
    }, [clientId, eventId, accountId1, accountId2]);
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const onFetchUserDetails = async (userIdsToFetch) => {
        if (!Array.isArray(userIdsToFetch) || userIdsToFetch.length === 0) {
            return;
        }
        await fetchUserDetails({
            chatClient,
            userIdsToFetch: userIdsToFetch,
            primaryUserId: userIdsToFetch[0],
            setUserDetails,
            setChatError,
        });
    };

    const toggleSidebar = () => {
        if (window.innerWidth <= Sizes.BREAKPOINT_TABLET) {
          setIsSidebarOpen((prev) => !prev);
        }
    }
    // Latest user picked; an older selection that finishes later must not replace its conversation
    const latestSelectedUserIdRef = useRef(null);
    const handleUserSelect = useCallback(
        (selectedUserId) => {            
            if (!chatClient || selectedUserId === primaryUserId) return;
            latestSelectedUserIdRef.current = selectedUserId;
            const isLatestSelection = () => latestSelectedUserIdRef.current === selectedUserId;
            setSidebarLoading(true); // Start loading
            // Set secondary immediately (sync)
            setSecondaryUserId(selectedUserId);
            toggleSidebar();

            // Continue the async flow separately; resolves to the opened channel, or null if it failed
            // or a newer selection replaced it
            return (async () => {
                const team = chatClient.user?.teams?.[0] || "";

                const newChannel = chatClient.channel("messaging", {
                    members: [primaryUserId, selectedUserId],
                    team,
                });

                await newChannel.create();

                await newChannel.watch({
                    watch: true,
                    state: true,
                    preserve_history: true,
                });
                if (!isLatestSelection()) return null;
                await onFetchUserDetails([primaryUserId, selectedUserId]);
                if (newChannel.data && newChannel.data.hidden === true) {
                    await newChannel.show();
                }
                chatClient.dispatchEvent({
                    type: "channel.created.custom",
                    channel: newChannel,
                });

                if (!isLatestSelection()) return null;
                setActiveChannel(newChannel);
                setSidebarLoading(false); // Stop loading when done
                return newChannel;
            })().catch((error) => {
                console.error("Failed to open conversation:", error);
                // A newer selection still in progress owns the loader
                if (isLatestSelection()) setSidebarLoading(false);
                return null;
            });
        },
        [chatClient, primaryUserId]
    );
    // Deep link from the website's My Schedule: open the appointment's conversation and its summary
    useOpenPendingAppointment(handleUserSelect);
    useRemoveCanceledAppointmentLink();
    const handleLoadMoreMessages = async () => {
        await loadMoreMessages({
            activeChannel,
            loadingMore,
            hasMore,
            setLoadingMore,
            setHasMore,
        });
    };
   

    //Reset modals when mode changes
    useEffect(() => {
        if (mode === "search") {
            setIsEditModalOpen(false);
            setIsDeleteModalOpen(false);
            setIsBlockModalOpen(false);
        }
    }, [mode]);

    const isOverlay = useOverlayActive(Sizes.BREAKPOINT_TABLET);

    function handleChannelAreaClick() {
        if (window.innerWidth <= Sizes.BREAKPOINT_TABLET) {
            setIsSidebarOpen(false);
        }
    }

    if (!clientId || !eventId || !primaryUserId) {
        return <Unauthorized/>;
    }
    if (error)
        return (
            <Unauthorized errorMessage="Failed to connect to the chat server. Please try again later."/>
        );
    if (chatError) return <Unauthorized errorMessage={chatError}/>;
    if (loading || !chatClient) return <EventScribeSpinner logovisible={true} />;

    return (
      <div className="chat-page-container">
        {!hideFCMBanner && <FCMNotificationBanner key={refreshBanner} />}
        <MemoizedHeader chatClient={chatClient} />

        <div className="chat-page-content">
          <div className={`chat-page-sidebar${isSidebarOpen ? "" : " closed"}${isOverlay ? " overlay" : ""}`}>
            <MemoizedSideBar
              mode={mode}
              setMode={setMode}
              chatClient={chatClient}
              onUserSelect={handleUserSelect}
              currentUserId={primaryUserId}
              chatUserId={secondaryUserId}
              onChatDeleteClick={onDeleteChannel}
              setSidebarLoading={setSidebarLoading}
              onRecentUsersCountChange={setHasRecentUsers}
              onBlockUserClick={handleShowBlockModal}
            />
          </div>

          <div
            className="chat-page-main"
            style={{ position: "relative" }}
            onClick={handleChannelAreaClick}
            aria-busy={sidebarLoading || deletingChannel || isDeletingMessage}
          >
            {sidebarLoading ? (
              <div className="chat-spinner-overlay" role="status" aria-live="polite">
                <EventScribeSpinner message="Loading chat, please wait..." />
              </div>
            ) : deletingChannel ? (
              <div className="chat-spinner-overlay" role="status" aria-live="polite">
                <EventScribeSpinner message="Conversation deleting, please wait..." />
              </div>
            ) : isDeletingMessage ? (
              <div className="chat-spinner-overlay" role="status" aria-live="polite">
                <EventScribeSpinner message="Deleting message, please wait..." />
              </div>
            ) : (
              <Chat client={chatClient} theme="messaging light">
                {activeChannel && mode !== "search" ? (
                  <Channel
                    key={activeChannel?.cid}
                    TypingIndicator={CustomTypingIndicator}
                    giphyVersion="fixed_height_small"
                    ThreadHeader={CustomThreadHeader}
                    MessageTimestamp={CustomMessageTimestamp}
                    Avatar={(props) => (
                      <CustomAvatar
                        {...props}
                        shouldShowAvatar={shouldShowAvatar}
                        timeThreshold={DAY_THRESHOLD}
                      />
                    )}
                    channel={activeChannel}
                    DateSeparator={MessageCustomDateSeparator}
                    EmptyStateIndicator={CustomEmptyState}
                    Input={(props) => <CustomInput {...props} disabled={isChatDisabled} />}
                    Message={CustomMessage}
                    MessageActions={(props) => (
                      <ChatMessageActions
                        {...props}
                        disabled={isChatDisabled}
                        onShowDeleteModal={handleShowDeleteModal}
                        onShowEditModal={handleShowEditModal}
                      />
                    )}
                  >
                    <Window>
                      <CustomChannelHeader onBackClick={() => setIsSidebarOpen(true)} />
                      <div className="message-list">
                        <MessageList
                          disableDateSeparator={false}
                          onlySenderCanEdit={true}
                          stickToBottomScrollBehavior="smooth"
                          onYReachStart={handleLoadMoreMessages}
                          LoadingIndicator={() =>
                            loadingMore && (
                              <div className="loading-indicator">
                                <EventScribeSpinner message="Loading chat.." />
                              </div>
                            )
                          }
                        />
                      </div>
                      <MessageInput
                        additionalMessageInputProps={{
                          focus: true,
                        }}
                        additionalTextareaProps={{
                          placeholder: "Send a message",
                        }}
                        hideSendButton="true"
                      />
                    </Window>
                    <Thread
                      enableDateSeparator={true}
                      TypingIndicator={CustomTypingIndicator}
                      Input={(props) => <CustomInput {...props} disabled={isChatDisabled} />}
                      additionalMessageInputProps={{
                        focus: true,
                        additionalTextareaProps: {
                          placeholder: "Send a message",
                        },
                      }}
                      additionalMessageListProps={{
                        onlySenderCanEdit: true,
                        EmptyStateIndicator: CustomEmptyState,
                      }}
                    />
                  </Channel>
                ) : (
                  !sidebarLoading && (
                    <EmptyChannelMessage
                      setMode={setMode}
                      mode={mode}
                      hasRecentUsers={hasRecentUsers}
                    />
                  )
                )}
              </Chat>
            )}
          </div>
          {/* Add the AppointmentPopupSummary modal */}
                {API_URLS.APP_ENABLE_SCHEDULE_APPOINTMENT && isAppointmentSummaryPopupOpen && (
                    <AppointmentPopupSummary 
                       
                    />
                )}

          <EditConfirmationModal
            isOpen={isEditModalOpen}
            toggle={() => setIsEditModalOpen(false)}
            onSave={handleEditMessage}
            editTitle={EDIT_USER_MESSAGE_TITLE}
            initialValue={messageToEdit?.text || ""}
          />

          <DeleteConfirmationModal
            isOpen={isDeleteModalOpen}
            toggle={() => setIsDeleteModalOpen(false)}
            onDelete={onDeleteMessage}
            deleteTitle={DELETE_USER_MESSAGE_TITLE}
            deleteMessage={DELETE_USER_SINGLE_MESSAGE}
            sidebarStateChangeKey={sidebarStateChangeKey}
          />
          <BlockUserConfirmationModal
            isOpen={isBlockModalOpen}
            toggle={handleCloseBlockModal}
            onBlock={handleBlockUser}
            title={BLOCK_USER_TITLE}
            message={BLOCK_USER_MESSAGE}
          />

          <ChatDisableModal
            isOpen={isModalOpen}
            toggle={closeModal}
            userDetails={userDetails}
            disableClose={!secondaryUserId}
          />
        </div>
        <AppointmentModal
          isOpen={isSchedulePopupOpen}
          iframeUrl={iframeUrl}
          targetOrigin="*"
          activeChannel={activeChannel}
          onClose={handleCloseModal}
          toggle={handleCloseModal}
        />
      </div>
    );
};

export default ChatPage;
// ✅ Memoized version of Sidebar
const MemoizedSideBar = React.memo(SideBar);
const MemoizedHeader = React.memo(Header);
